
import { Component, Vue, Prop } from 'vue-property-decorator';
import stores from '@/stores';
import { SweetModal } from 'sweet-modal-vue';

@Component({
  components: {
    SweetModal,
  },
})

export default class CreateNewDevice extends Vue {
  deviceGroup = this.initialDeviceGroup();

  @Prop({default: false})
  emitCreated!: boolean;

  cancel() {
    (this.$refs.form as HTMLFormElement).classList.remove('was-validated');
    this.deviceGroup = this.initialDeviceGroup();
    (this.$refs.create as any).close();
  }

  validateForm() {
    const form = this.$refs.form as HTMLFormElement;
    form.classList.add('was-validated');

    if (form.checkValidity() === true) {
      this.save();
    }
  }

  initialDeviceGroup(): IDeviceGroup {
    return {
      id: null,
      name: '',
      shortDescription: '',
      active: true,
      sort: null,
      default: null,
      devices: [],
      type: null,
    };
  }

  async save() {
    if (this.deviceGroup) {
      try {
        const response = await stores.DeviceGroups.createDeviceGroup(this.deviceGroup);
        if (this.emitCreated) {
          this.$emit('created', response as IDeviceGroup);
          this.cancel();
          return;
        }
        this.cancel();
        this.$router.push({ name: 'deviceGroup.show', params: { id: response.id } });
      } catch (e) {
        console.log(e);
      }
    }
  }
}
